import request from '@/utils/request'

export function login(username, password, code, uuid) {
  return request({
    url: 'auth/login',
    method: 'post',
    data: {
      username,
      password,
      code,
      uuid
    }
  })
}

export function getInfo() {
  return request({
    url: 'auth/info',
    method: 'get'
  })
}

export function getCodeImg() {
  return request({
    url: 'auth/vCode',
    method: 'get'
  })
}

export function signUpEnterprise(data) {
  console.log(data)
  return request({
    url: 'api/signUpEnterprise',
    method: 'post',
    data
  })
}
export function signUpSupplier(data) {
  console.log(data)
  return request({
    url: 'api/signUpSupplier',
    method: 'post',
    data
  })
}